module.exports = __webpack_public_path__ + "img/uk-infectious-diseases-female.9de96693.png";